<template>
  <div id="folder-picker" class="card p-1">
    <p class="text-center mb-1"><strong>Choose a Location</strong></p>
    <div
      class="mb-2"
    >
      <span
        v-for="(crumb, i) in breadcrumbs"
        v-bind:key="i"
      >
        <b-badge
          pill
          variant="primary"
          @click="launchFolder(crumb, true)"
          class="clickable"
        >{{ crumb.name }}</b-badge><span v-if="(i + 1) !== breadcrumbs.length"> / </span>
      </span>
    </div>
    <div class="card p-2 scroll">
      <!-- FOLDERS -->
      <div class="list-group mb-2 folders" v-if="!loadingFolders">
        <div
          v-for="(folder, i) in $store.state.translator.folders"
          v-bind:key="i"
          class="list-container"
        >
          <a
            @click="launchFolder(folder)"
            class="list-group-item list-group-item-action clickable mb-2 folder"
          >
            <p class="lead mb-1"><i class="fas fa-folder"></i> {{ folder.name }}</p>
            <p class="mb-1">{{ folder.description }}</p>
          </a>
        </div>
      </div><!-- /.list-group -->
      <!-- DATASETS -->
      <div class="list-group sets" v-if="!loadingDatasets">
        <div
        v-for="(dataset, i) in $store.state.translator.datasets"
        v-bind:key="i"
        class="list-container"
        >
          <a class="list-group-item list-group-item-action handle mb-2">
            <p class="lead mb-1"><i v-if="dataset.dynamic" class="fas fa-satellite-dish" v-b-tooltip.hover.top="'Dynamic Dataset'"></i> {{ dataset.name }}</p>
            <p class="mb-1">{{ dataset.description }}</p>
          </a>
        </div>
      </div><!-- /.list-group -->
    </div><!-- /.card -->
  </div><!-- /#dataset-picker -->
</template>

<script>
const fb = require('@/firebaseConfig.js')

export default {
  data () {
    return {
      loadingFolders: true,
      loadingDatasets: true
    }
  },
  computed: {
    breadcrumbs: {
      get () {
        return this.$store.state.translator.breadcrumbs
      },
      set (value) {
        this.$store.commit('translator/setStateProperty', { property: 'breadcrumbs', value: value })
      }
    }
  },
  created () {
    this.fetchDatasets()
    this.fetchFolders()
  },
  methods: {
    fetchDatasets () {
      this.loadingDatasets = true
      const farmId = this.$store.state.translator.farm.id
      const folderId = this.$store.state.translator.folder.id
      fb.datasetsCollection
        .where('farmId', '==', farmId)
        .where('folderId', '==', folderId)
        .orderBy('updatedOn', 'desc')
        .get()
        .then(snap => {
          const datasets = snap.docs.map(d => ({ id: d.id, ...d.data() }))
          this.$store.commit('translator/setStateProperty', { property: 'datasets', value: datasets })
          this.loadingDatasets = false
        }).catch(err => {
          console.log(err.message)
          this.loadingDatasets = false
        })
    },
    fetchFolders () {
      this.loadingFolders = true
      const farmId = this.$store.state.translator.farm.id
      const folderId = this.$store.state.translator.folder.id
      fb.foldersCollection
        .where('farmId', '==', farmId)
        .where('folderId', '==', folderId)
        .orderBy('name', 'asc')
        .get()
        .then(snap => {
          const folders = snap.docs.map(d => ({ id: d.id, ...d.data() }))
          this.$store.commit('translator/setStateProperty', { property: 'folders', value: folders })
          this.loadingFolders = false
        }).catch(err => {
          console.log(err.message)
          this.loadingFolders = false
        })
    },
    launchFolder (folder, fromCrumb) {
      if (this.breadcrumbs.length < 1) {
        this.breadcrumbs = [{ name: 'Root', id: 'root' }]
      }
      if (fromCrumb) {
        const newBreadcrumbs = []
        this.breadcrumbs.some(crumb => {
          if (crumb.id !== folder.id) {
            newBreadcrumbs.push(crumb)
          } else {
            newBreadcrumbs.push(crumb)
            return true
          }
        })
        this.breadcrumbs = newBreadcrumbs
      } else {
        this.breadcrumbs.push(folder)
      }
      this.$store.commit('translator/setStateProperty', { property: 'folder', value: folder })
      this.fetchDatasets()
      this.fetchFolders()
    },
    launchDataset (dataset) {
      this.$store.commit('translator/setStateProperty', { property: 'dataset', value: dataset })
      this.$store.commit('translator/showOptions', true)
    }
  }
}
</script>

<style scoped>
/* Cap the picker so a long list of folders scrolls inside the
   sidebar instead of pushing the Download / save controls below
   the fold. */
.scroll {
  max-height: 260px;
  overflow-y: auto;
}
.card > .list-group {
  border-top: none;
  border-bottom: none;
}
.folder {
  background-color: #eee;
}

.badge.clickable:hover {
  box-shadow: 1px 2px 4px rgba(0,0,0,0.5);
}
</style>
